import React, { useContext } from 'react';
import Table from '../../components/Table';
import { GlobalContext } from '../../context/GlobalContext';
import { AlertTriangle } from 'lucide-react';

export default function Ventas() {
	const { userData } = useContext(GlobalContext);

	if (!userData?.email) return null;

	return (
		<div className="h-full w-full p-4 md:p-6">
			<Table
				userEmail={userData.master_store.id}
				endpoint="https://api.krece.app/tables/devices/"
				pagination={{ default: 100, batchSizes: [100] }}
				orderBy={{ columnName: 'Fecha de Compra', columnOrder: 'DESC' }}
				allowExportWithoutTotal
				cellRenderers={{
					Estado: (value) =>
						value === 'Venta anulada' ? (
							<span className="inline-flex items-center gap-1 rounded bg-red-500/10 px-2 py-1 text-xs font-medium text-red-700 dark:bg-red-500/20 dark:text-red-400">
								<AlertTriangle className="size-3.5" />
								Venta anulada
							</span>
						) : (
							<span className="inline-flex rounded bg-neutral-800 px-2 py-1 text-xs font-medium text-neutral-200">
								Venta registrada
							</span>
						)
				}}
				filters={[
					{
						column: 'Sucursal',
						options: [
							{ label: 'Todas las sucursales', value: 'Todas las sucursales' },
							...[...(userData?.sub_stores || [])].map((e) => ({ label: e, value: e }))
						],
						defaultValue: 'Todas las sucursales'
					},
					{
						column: 'Estado',
						options: [
							{ label: 'Todas las ventas', value: 'Todas las ventas' },
							{ label: 'Excluir anuladas', value: 'Excluir anuladas' }
						],
						defaultValue: 'Todas las ventas'
					}
				]}
				search_by={[
					{ column: 'IMEI no', placeholder: 'Buscar IMEI...', type: 'numeric', label: 'IMEI' },
					{ column: 'Número de confirmación', placeholder: 'Buscar número de confirmación...', type: 'numeric', label: 'Num. de confirmación' },
					{ column: 'Cédula', placeholder: 'Buscar cédula...', type: 'numeric', label: 'Cédula' }
				]}
			/>
		</div>
	);
}
